import type { VolumeUnit, WeightUnit } from './types';

export const ML_PER_OZ = 29.5735;

export function mlToDisplay(ml: number, unit: VolumeUnit): string {
  if (unit === 'ml') return `${Math.round(ml)} ml`;
  const oz = ml / ML_PER_OZ;
  const rounded = Math.round(oz * 4) / 4; // quarter-ounce steps
  return `${rounded} oz`;
}

export function displayToMl(value: number, unit: VolumeUnit): number {
  return unit === 'ml' ? value : value * ML_PER_OZ;
}

const G_PER_LB = 453.592;
const G_PER_OZ_W = 28.3495;

export function gramsToDisplay(grams: number, unit: WeightUnit): string {
  if (unit === 'g') return `${Math.round(grams)} g`;
  const lb = Math.floor(grams / G_PER_LB);
  const oz = Math.round((grams - lb * G_PER_LB) / G_PER_OZ_W);
  if (oz === 16) return `${lb + 1} lb 0 oz`;
  return `${lb} lb ${oz} oz`;
}

export function lbOzToGrams(lb: number, oz: number): number {
  return lb * G_PER_LB + oz * G_PER_OZ_W;
}

/** Percent change from birth weight; negative = loss. */
export function weightChangePct(currentG: number, birthG: number): number {
  return ((currentG - birthG) / birthG) * 100;
}
